<template>
  <v-dialog
    v-model="followersDialog"
    persistent
    scrollable
    max-width="800"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        :title="$t('supportTicketDialogFollowers.title')"
        v-on="on"
        small
        @click="followersDialogInit"
      >
        <v-icon>
          mdi-account-switch-outline
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title white--text secondary">
        {{ $t('supportTicketDialogFollowers.title') }}
      </v-card-title>
      <v-card-text>
        <Loading :loading="!loaded" />

        <v-container
          v-if="loaded"
          fluid
        >
          <v-row>
            <v-col>
              <h2>{{ $t('supportTicketDialogFollowers.persons.title') }}</h2>
              <vMultiselectListbox 
                v-model="selectedPersons"
                :options="followersModel.metadata.persons"
                :reduce-display-property="(option) => option.text"
                :reduce-value-property="(option) => option.value"
                :search-options-placeholder="$t('supportTicketDialogFollowers.persons.searchOptions')"
                :selected-options-placeholder="$t('supportTicketDialogFollowers.persons.searchSelected')"
                :no-options-text="$t('supportTicketDialogFollowers.persons.noOption')"
                :selected-no-options-text="$t('supportTicketDialogFollowers.persons.noSelected')"
                :no-options-found-text="$t('supportTicketDialogFollowers.persons.noOptionFound')"
                :no-selected-options-found-text="$t('supportTicketDialogFollowers.persons.noSelectedFound')"
                @change="hasChanged = true"
              />
            </v-col>
          </v-row>
        </v-container>
        <v-container
          v-if="loaded"
          fluid
        >
          <v-row>
            <v-col>
              <h2>{{ $t('supportTicketDialogFollowers.departments.title') }}</h2>
              <vMultiselectListbox 
                v-model="selectedDepartments"
                :options="followersModel.metadata.departments"
                :reduce-display-property="(option) => option.text"
                :reduce-value-property="(option) => option.value"
                :search-options-placeholder="$t('supportTicketDialogFollowers.departments.searchOptions')"
                :selected-options-placeholder="$t('supportTicketDialogFollowers.departments.searchSelected')"
                :no-options-text="$t('supportTicketDialogFollowers.departments.noOption')"
                :selected-no-options-text="$t('supportTicketDialogFollowers.departments.noSelected')"
                :no-options-found-text="$t('supportTicketDialogFollowers.departments.noOptionFound')"
                :no-selected-options-found-text="$t('supportTicketDialogFollowers.departments.noSelectedFound')"
                @change="hasChanged = true"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          color="primary"
          @click="followersDialogCancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="secondary"
          :loading="saving"
          :disabled="!hasChanged"
          @click="followersDialogSave"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from '@/components/Loading'

export default {
  name: 'SupportTicketDialogFollowers',
  components: {
    Loading
  },
  data() {
    return {
      followersModel: Object,
      followersDialog: false,
      loaded: false,
      saving: false,
      hasChanged: false,
      selectedPersons: [],
      selectedDepartments: []
    };
  },
  methods: {
    followersDialogInit: async function () {
      this.hasChanged = false;

      var response = await this.$api.get(`supportticket/changefollowers/${this.$route.params.id}`);
      this.followersModel = response.data;
      this.selectedPersons = this.followersModel.data.followerPersonIds.map(x => this.followersModel.metadata.persons.find(y => y.value === x));
      this.selectedDepartments = this.followersModel.data.followerDepartmentIds.map(x => this.followersModel.metadata.departments.find(y => y.value === x));
      this.followersDialog = true;
      this.loaded = true;
    },
    followersDialogSave: async function () {
      this.saving = true;

      var response = await this.$api.put(`supportticket/changefollowers/${this.$route.params.id}`, {
        followerDepartmentIds: this.selectedDepartments.map(x => x.value),
        followerPersonIds: this.selectedPersons.map(x => x.value)
      });

      if (response.data.success) {
        this.followersDialog = false;
        this.saving = false;
        this.$emit("saved");
      }
    },
    followersDialogCancel: function () {
      this.followersDialog = false;
      this.loaded = false;
    },
  }
};
</script>